import { Col, Row } from "antd";
import Form from "antd/lib/form/Form";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { PER_ACCESS_PAGES, PER_AUTH_DIV } from "common/constant";
import useAuth from "common/hooks/useAuth";

import { masterDataApi } from "services/masterData";

import {
  flowAccountStore,
  setIsEmptyBillingAction,
  setListBillingAddressAction
} from "store/slices/flowAccount";

import "./HeadOfficePartners.scss";
import ListChosePartner from "./ListChosePartner";
import TableListPartners from "./TableListPartners";

import InputFilter from "components/filter/InputFilter";
import TitleDetail from "components/form/TitleDetail";

const ShippingPartners = ({ editMode }) => {
  const { listBillingAddress, isEmptyBilling } = useSelector(flowAccountStore);
  const dispatch = useDispatch();
  const { authPer } = useAuth();

  const [listPartners, setListPartners] = useState();
  const [params, setParams] = useState({ page: 1 });
  const [totalRecords, setTotalRecords] = useState();
  const [sortParams, setSortParams] = useState([]);
  const [canEdit, setCanEdit] = useState();

  const initFlag = useRef(false);

  const setListBillingAddress = (params) => {
    dispatch(setListBillingAddressAction(params));
  };

  const handleFilter = (changedFields) => {
    setParams({
      ...params,
      [changedFields[0].name[0]]: changedFields[0].value,
      page: 1
    });
  };

  const handleChangePage = (currentPage) => {
    setParams({ ...params, page: currentPage });
  };

  const handleSortOrders = (pagination, _, sorter) => {
    const paramSort = sorter.field === "name" ? "billing_addr_nm" : "billing_addr_cd";
    if (pagination.current === params.page) {
      if (sorter.length > 1) {
        setSortParams(
          sorter.map((item) => (item.order === "descend" ? `-${paramSort}` : paramSort))
        );
      } else if (sorter.column) {
        setSortParams([sorter.order === "descend" ? `-${paramSort}` : paramSort]);
      } else {
        setSortParams([]);
      }
    }
  };

  const fetchListTransportAddress = async () => {
    const res = await masterDataApi.getListTransportAddress({
      ...params,
      sort: sortParams
    });
    const listIdExist = listBillingAddress?.map((e) => e.id);
    const listPartnersTemp = res.items?.map((item) => ({
      id: item?.billing_addr_cd,
      name: item?.billing_addr_nm
    }));
    setListPartners(listPartnersTemp?.filter((item) => !listIdExist?.includes(item.id)));
    setTotalRecords(res.total);
  };

  const handleRemoveItem = async (idRemove) => {
    const res = await masterDataApi.getListTransportAddress({
      ...params,
      sort: sortParams
    });
    const listBillingAddressTemp = listBillingAddress.filter((item) => item.id !== idRemove);
    setListBillingAddress(listBillingAddressTemp);
    const listIdExist = listBillingAddressTemp?.map((e) => e.id);
    const listPartnersTemp = res.items?.map((item) => ({
      id: item?.billing_addr_cd,
      name: item?.billing_addr_nm
    }));
    setListPartners(listPartnersTemp?.filter((item) => !listIdExist?.includes(item.id)));
    setTotalRecords(res.total);
  };

  useEffect(() => {
    setCanEdit(authPer && authPer[PER_ACCESS_PAGES.ADD_TRANS] === PER_AUTH_DIV.CRUD);
  }, [authPer]);

  useEffect(() => {
    fetchListTransportAddress();
  }, [params, sortParams]);

  useEffect(() => {
    if (initFlag.current && listBillingAddress.length === 0)
      dispatch(setIsEmptyBillingAction(true));
    else dispatch(setIsEmptyBillingAction(false));
    if (!initFlag.current) {
      initFlag.current = true;
    }
    const listIdTemp = listBillingAddress?.map((e) => e.id);
    setListPartners((preState) => preState?.filter((item) => !listIdTemp?.includes(item.id)));
  }, [listBillingAddress]);

  return (
    <Col span={18}>
      <div className={`${!canEdit && editMode && "disable"} head-office-partners`}>
        <TitleDetail title="運送請求先の追加" />
        {isEmptyBilling && <div className="msg-err">運送請求先を追加して下さい</div>}
        <Row className="partner-content">
          <Col span={10}>
            <ListChosePartner partners={listBillingAddress} handleRemoveItem={handleRemoveItem} />
          </Col>
          <Col span={14}>
            <Form
              name="basic"
              onFieldsChange={handleFilter}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              autoComplete="off"
            >
              <Row gutter={[16]}>
                <InputFilter
                  title="請求先コード"
                  placeholder="テキスト入力"
                  name="billing_addr_cd"
                />
                <InputFilter title="請求先名称" placeholder="テキスト入力" name="billing_addr_nm" />
              </Row>
            </Form>
            <TableListPartners
              rowKey={(record) =>
                `${record.billing_addr_cd}_${record.office_cd}_${record.company_cd}`
              }
              isShipPartner
              setPartners={setListBillingAddress}
              partners={listBillingAddress}
              dataSource={listPartners}
              setListPartners={setListPartners}
              page={params.page}
              totalRow={totalRecords}
              onChangePage={handleChangePage}
              onSortOrders={handleSortOrders}
              dataIndexes={{ id: "billing_addr_cd", name: "billing_addr_nm" }}
            />
          </Col>
        </Row>
      </div>
    </Col>
  );
};

ShippingPartners.propTypes = {
  editMode: PropTypes.bool
};

export default ShippingPartners;
